import _ from "lodash";
import { WARNING_REDIRECT } from "constants/action-types";
import { push } from "react-router-redux";
import { IWarningState } from "reducers/warning-reducers";
import { IStore } from "reducers";
import { LocationDescriptor } from "history";
import { Dispatch } from "react-redux";

export const updateWarningState = (payload: Partial<IWarningState>) => (dispatch: Dispatch<{}>) => {
    if (_.has(payload, "showAgain")) {
        if (!payload.showAgain) {
            sessionStorage.setItem("hide-redirect-warning", "true");
        } else {
            sessionStorage.removeItem("hide-redirect-warning");
        }
    }

    return dispatch({
        type: WARNING_REDIRECT.UPDATE,
        payload,
    });
};

export const clearWarningState = () => ({ type: WARNING_REDIRECT.CLEAR });

export const handleRedirect = (redirect: LocationDescriptor) => (dispatch: Dispatch<{}>) => {
    dispatch(push(redirect));
    dispatch(clearWarningState());
};

export const redirectWithWarning =
    (redirect: LocationDescriptor) => (dispatch: Dispatch<{}>, getState: () => IStore) => {
        const { warning } = getState();
        if (warning.notify && warning.showAgain) {
            dispatch(updateWarningState({ show: true, redirect }));
        } else {
            dispatch(handleRedirect(redirect));
        }
    };
